import { MRT_ColumnDef, createMRTColumnHelper } from "material-react-table";
import { useTranslation } from "react-i18next";

import { GridText } from "src/components/Grid/GridText";
import { MrtColumns } from "src/components/Grid/hooks/columnsExtension/useGridColumns";
import { IngredientReference } from "src/api/client-api/ingredientReference/useAllIngredientReferences";

type Options = {
    ingredientReferences?: IngredientReference[];
};

export const useIngredientReferenceColumns = (options: Options): MrtColumns<IngredientReference> => {
    const { t } = useTranslation();

    const columnHelper = createMRTColumnHelper<IngredientReference>();

    const mrt_columns = [
        columnHelper.accessor((row) => row.id, {
            id: "id",
            header: t("ingredientReferences.id", "ID"),
            Cell: (value) => <GridText value={value.renderedCellValue} />,
        }),
        columnHelper.accessor("name", {
            header: t("ingredientReferences.name", "Name"),
            Cell: (value) => <GridText value={value.renderedCellValue} />,
        }),
        columnHelper.accessor("code", {
            header: t("ingredientReferences.code", "Code"),
            Cell: (value) => <GridText value={value.renderedCellValue || "-"} />,
        }),
        columnHelper.accessor("description", {
            header: t("ingredientReferences.description", "Description"),
            Cell: (value) => <GridText value={value.renderedCellValue || "-"} />,
        }),
        columnHelper.accessor("cpcCode", {
            header: t("ingredientReferences.cpcCode", "CPC Code"),
            Cell: (value) => <GridText value={value.renderedCellValue || "-"} />,
        }),
        columnHelper.accessor("defaultOrigin", {
            header: t("ingredientReferences.defaultOrigin", "Default Origin"),
            Cell: (value) => <GridText value={value.renderedCellValue || "-"} />,
        }),
    ] as MRT_ColumnDef<IngredientReference, string>[];

    return mrt_columns;
};
